module.exports = __webpack_public_path__ + "img/1c.627357a9.png";